import { useEffect, useState } from "react";
import {
  SCREENS,
  shikshakInstructionContent,
} from "../utils/CommonUtils/constants";
import OnBoardingScreen from "../screens/OnBoardingScreen/OnBoardingScreen";
import NeedPermissionsScreen from "../screens/NeedPermissionsScreen/NeedPermissionsScreen";
import VopaInstructionScreen from "../screens/VopaInstructionScreen/VopaInstructionScreen";
import AssessmentLoadingScreen from "../screens/AssessmentLoadingScreen/AssessmentLoadingScreen";
import AssessmentScreen from "../screens/assessmentScreen/AssessmentScreen";
import useTranslationSetup from "../utils/useTranslationSetup";
import useWebViewBridge from "../utils/useWebViewBridge";

const AssessmentFlow = () => {
  const { t } = useTranslationSetup();
  const { sendMessageToReactNative } = useWebViewBridge();
  const [activeScreen, setActiveScreen] = useState(
    SCREENS.RENDER_ONBOARDING_SCREEN
  );
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [createAssessmentResponse, setCreateAssessmentResponse] =
    useState(null);

  const renderActiveScreen = () => {
    switch (activeScreen) {
      case SCREENS.RENDER_ONBOARDING_SCREEN:
        return <OnBoardingScreen setActiveScreen={setActiveScreen} />;
      case SCREENS.RENDER_NEED_PERMISSION_SCREEN:
        return (
          <NeedPermissionsScreen
            setActiveScreen={setActiveScreen}
            setLatitude={setLatitude}
            setLongitude={setLongitude}
          />
        );
      case SCREENS.RENDER_INSTRUCTIONS_SCREEN:
        return (
          <VopaInstructionScreen
            instructionContent={shikshakInstructionContent(t, "assessment")}
            setActiveScreen={setActiveScreen}
            flowType="assessment"
          />
        );
      case SCREENS.RENDER_ASSESSMENT_LOADING_SCREEN:
        return (
          <AssessmentLoadingScreen
            setCreateAssessmentResponse={setCreateAssessmentResponse}
            latitude={latitude}
            longitude={longitude}
          />
        );
      case SCREENS.RENDER_ASSESSMENT_SCREEN:
        return (
          <AssessmentScreen
            createAssessmentResponse={createAssessmentResponse}
          />
        );
      default:
        break;
    }
  };

  useEffect(() => {
    if (createAssessmentResponse) {
      setActiveScreen(SCREENS.RENDER_ASSESSMENT_SCREEN);
      sendMessageToReactNative("status=CREATED");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createAssessmentResponse]);

  return <>{renderActiveScreen()}</>;
};

export default AssessmentFlow;
